import { useState } from "react";
import { toast } from "sonner";
import { Reveal } from "./Reveal";
import { Divider, HennaHand, Paisley } from "../HennaMotif";
import { submitRsvp } from "../../lib/api";

export const Rsvp = () => {
  const [name, setName] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name.trim()) {
      toast.error("Lütfen adınızı yazın.");
      return;
    }
    if (!message.trim()) {
      toast.error("Lütfen bir mesaj yazın.");
      return;
    }
    setLoading(true);
    try {
      await submitRsvp({
        name: name.trim(),
        guests: 1,
        attending: true,
        message: message.trim(),
      });
      setDone(true);
      toast.success("Mesajınız için teşekkürler, kalbimize dokundu.");
    } catch (err) {
      toast.error("Bir şeyler ters gitti, lütfen tekrar deneyin.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section
      id="mesaj"
      data-testid="message-section"
      className="relative py-32 md:py-48"
    >
      <HennaHand className="pointer-events-none absolute left-6 top-24 h-40 w-32 -rotate-12 text-gold/30 md:left-16 md:h-56 md:w-44" />
      <HennaHand className="pointer-events-none absolute bottom-24 right-6 h-40 w-32 rotate-12 scale-x-[-1] text-gold/30 md:right-16 md:h-56 md:w-44" />
      <Paisley className="pointer-events-none absolute right-1/4 top-10 hidden h-24 w-20 text-gold/25 md:block" />
      <div className="mx-auto max-w-3xl px-6 md:px-10">
        <Reveal className="mb-14 text-center">
          <p className="mb-6 font-sans text-xs uppercase tracking-[0.35em] text-gold">
            İyi Dilekler
          </p>
          <h2 className="font-serif text-4xl leading-tight tracking-tight text-cream md:text-6xl">
            Bize bir <span className="italic text-gold">mesaj</span> bırakın
          </h2>
          <p className="mx-auto mt-5 max-w-md font-sans text-sm font-light text-sand">
            Bir dilek, bir tebrik ya da güzel bir hatıra — hepsini okuyacak ve kalbimizde saklayacağız.
          </p>
        </Reveal>

        {done ? (
          <Reveal className="text-center" data-testid="message-success">
            <div className="rounded-sm border border-gold/30 bg-surface/60 px-8 py-16">
              <p className="font-serif text-3xl italic text-gold">Mesajınız için teşekkürler</p>
              <p className="mt-4 font-sans text-sand">15 Kasım&apos;da görüşmek dileğiyle.</p>
              <div className="mt-8"><Divider /></div>
            </div>
          </Reveal>
        ) : (
          <Reveal delay={0.1}>
            <form onSubmit={handleSubmit} className="space-y-10" data-testid="message-form">
              <div className="field">
                <input
                  id="msg-name"
                  data-testid="message-name-input"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  placeholder=" "
                  autoComplete="name"
                />
                <label htmlFor="msg-name">Adınız Soyadınız</label>
              </div>

              <div className="field">
                <textarea
                  id="msg-body"
                  data-testid="message-body-input"
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  placeholder=" "
                  rows={4}
                />
                <label htmlFor="msg-body">Mesajınız</label>
              </div>

              <button
                type="submit"
                data-testid="message-submit-button"
                disabled={loading}
                className="group w-full rounded-full bg-henna px-8 py-5 font-sans text-sm uppercase tracking-[0.25em] text-cream transition-all duration-300 hover:bg-henna-hover disabled:opacity-60"
              >
                {loading ? "Gönderiliyor..." : "Mesajı Gönder"}
              </button>
            </form>
          </Reveal>
        )}
      </div>
    </section>
  );
};
